import { useState, useEffect } from "react";
import { useParams } from "react-router";
// contexts
import { useUserData } from "../context/UserDataContext";
// hooks
import useSend from "../hooks/useSend";
import useStorage, { StorageKeys } from "../hooks/useStorage";
// services
import { Storage } from "../services/storage";
// types
import type { Gateway, GatewayId } from "../types/gateway";
import type { CmdGetGateway } from "../types/gupport";

type RouteParams = {
	gatewayId?: GatewayId;
};

const useSelectedGateway = () => {
	const send = useSend();
	const params = useParams<RouteParams>();

	const { ready } = useUserData();

	const [loading, setLoading] = useState(false);
	const [gateway, setGateway] = useState<Gateway | null>(null);
	const [storedGatewayId] = useStorage(StorageKeys.gatewayId);

	const gatewayId = params.gatewayId ?? storedGatewayId ?? undefined;

	useEffect(() => {
		if (gatewayId) {
			if (ready) {
				setLoading(true);
				const cmd = {
					action: "getGateway",
					gatewayId: gatewayId,
				} as const satisfies CmdGetGateway;
				send(cmd, (error, msg) => {
					if (!error && msg?.payload.status === "ok") {
						Storage.set(StorageKeys.gatewayId, gatewayId);
						setGateway(msg.payload.data);
					} else {
						setGateway(null);
					}
					setLoading(false);
				});
			}
		} else {
			Storage.remove(StorageKeys.gatewayId);
			Storage.remove(StorageKeys.gatewaysTab);
			setGateway(null);
		}
	}, [ready, gatewayId]);

	return { gateway, loading };
};

export default useSelectedGateway;
